

export function converDateStringToReadable(dateString) {
  let date = new Date(dateString);

  let suffix = date.getHours() >= 12 ? "pm" : "am";

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}${suffix}`;
}
